<template>
  <div class="">
    <div class="row">
      <div class="col-md-12 col-sm-8">
        <div class="card card-default widget animated">
          <div class="card-heading">
            <form v-on:submit="createUsers">
              <div class="col-md-5">
                <h5>Information</h5>
                <br>
                <form-textarea label="User Emails" name="emails" v-model="emails" validation="required|emaillist"></form-textarea>
                <br>
                <p>* Note, when user goes to login for the first time they will need to enter their email 
                  then click "Trouble signing in?" in order to reset their password through email. This 
                  ensures password integrity and security for users.
                </p>
              </div>
              <br>
              <div class="col-md-5">
                <div class="form-group">
                    <button type="submit" class="btn btn-success btn-lg">Create</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div><!-- /.col-md-9 -->
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import { Validator } from 'vee-validate';
import VueMask from 'v-mask'
import FormText from '../../elements/Form/FormText'
import FormTextArea from '../../elements/Form/FormTextArea'
import FormSelect from '../../elements/Form/FormSelect'
import database from '../../webmaster/Database/database'
import firebase from 'firebase'
import axios from 'axios'

Vue.use(VueMask);
Vue.use(VeeValidate);

export default {
  name: 'createsingleuser',
  components:{
    'form-text':FormText,
    'form-textarea':FormTextArea,
    'form-select':FormSelect
  },
  data () {
    return {
      emails: "",
      bla: "",
    }
  },
  created: function(){
    var self = this
    Validator.extend('emaillist', {
      getMessage: field => 'The ' + field + ' field must be a list of valid emails.',
      validate(value, args) {
        var emailArray = self.emails.split(',')
        for (var i = 0; i < emailArray.length; i++) { 
          if (self.validateEmail(emailArray[i])){
            continue
          } else {
            return false
          }
        }
        return true
      }
    });
  },
  methods: {
    validateEmail: function(email) {
      var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(email).toLowerCase())
    },
    createUsers:function(e){
      e.preventDefault()
      var self = this
      let promises = [];

      for (let child in this.$refs) {
        promises.push(this.$refs[child].$validator.validateAll());
      }
      Promise.all(promises).then(this.$validator.validateAll()).then(() => { 
        // Get a key for a new org.
        firebase.auth().currentUser.getIdToken().then(function(idToken){
          var newUserEmails = self.emails.split(',')
          var itemsProcessed = 0;

          newUserEmails.forEach(email => {
            axios.get('https://us-central1-premises-2af49.cloudfunctions.net/app/users/create', {
              headers: { "Authorization": "Bearer " +  idToken},
              params: {
                email: email,
                role: "3",
                org: self.$store.state.usermain.curOrg.id,
                orgName: self.$store.state.usermain.curOrg.name
              }
            }).then((resp) => {
              console.log(resp);
              itemsProcessed++;
              if (itemsProcessed === newUserEmails.length) {
                self.$router.push('/admin/users')
              }
            })
          })
        }).catch(err => {
            console.log(err);
            self.$swal('Oops...',
                  'An error occured while adding these users!',
                  'error')
        });
      }, () => {});
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// CreateMultipleUsers.vue?2b9bf354